/**
 * @generated SignedSource<<38f32ee2b733636b57350901f6694868>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbSharedRelatedSeller_seller$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedRelatedSellerTitle_seller">;
  readonly " $fragmentType": "SbSharedRelatedSeller_seller";
};
export type SbSharedRelatedSeller_seller$key = {
  readonly " $data"?: SbSharedRelatedSeller_seller$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedRelatedSeller_seller">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedRelatedSeller_seller",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRelatedSellerTitle_seller"
    }
  ],
  "type": "Seller",
  "abstractKey": null
};

(node as any).hash = "664ac1ce13280a971d7c9cb34b0a3a4d";

export default node;
